import { t } from 'i18next'
import { Button } from 'primereact/button'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import React, { useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import i18n from '../../../../../i18n'
import { Phone, PhoneType, phoneTypes } from '../../../../../util/phone'
import { PhoneTableProps } from '../interfaces/PhoneTableProps'

export const PhoneTable = (props: PhoneTableProps) => {
  const [newPhoneNumber, setNewPhoneNumber] = useState('')
  const [newPhoneType, setNewPhoneType] = useState<PhoneType>()
  const { control, getValues } = useFormContext()
  const [showDuplicatedDialog, setShowDuplicatedDialog] =
    useState<boolean>(false)
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'phone',
  })
  const currentPhoneNumbers = getValues('phone')

  const isButtonDisabled = () =>
    newPhoneType === undefined || newPhoneNumber === ''

  const checkIfDuplicated = () => {
    if (
      currentPhoneNumbers
        .map((phone: Phone) => phone.phone_number)
        .includes(newPhoneNumber)
    ) {
      setShowDuplicatedDialog(true)
    } else {
      addPhone({ phone_number: newPhoneNumber, phone_type: newPhoneType })
    }
  }

  const addPhone = (value: any) => {
    append(value)
    setNewPhoneNumber('')
    setNewPhoneType(undefined)
  }

  const removePhone = (index: number, phone: any) => {
    remove(index)
    props.phoneNumbersToRemove.push(phone)
  }

  const typeTemplate = (option: any) => {
    if (!option?.label) {
      return (
        <div style={{ minWidth: '120px' }}>
          <i className={'fas fa-question-circle icon-dark-gray mr-2'} />{' '}
          <span>{t<string>('core.select')}</span>
        </div>
      )
    }
    return (
      <div style={{ minWidth: '120px' }}>
        <i className={option?.icon + ' icon-dark-gray mr-2'} />{' '}
        <span>{option?.label}</span>
      </div>
    )
  }

  return (
    <>
      {fields.map((phone, index) => {
        return (
          <div key={phone.id}>
            <div className="p-fluid formgrid grid">
              <div className="field col-4">
                <Controller
                  render={({ field }) => (
                    <Dropdown
                      placeholder={i18n.t<string>('core.select')}
                      options={phoneTypes}
                      itemTemplate={typeTemplate}
                      valueTemplate={typeTemplate}
                      {...field}
                    />
                  )}
                  defaultValue={phone}
                  control={control}
                  name={`phone[${index}].phone_type`}
                />
              </div>
              <div className="field col-5">
                <Controller
                  render={({ field }) => (
                    <InputText
                      maxLength={60}
                      placeholder={'+41 79 123 45 67'}
                      {...field}
                    />
                  )}
                  defaultValue={phone}
                  control={control}
                  name={`phone[${index}].phone_number`}
                />
              </div>
              <div className="field col-3">
                <Button
                  className="p-button-danger p-button-outlined"
                  type="button"
                  onClick={() => removePhone(index, phone)}
                >
                  {i18n.t<string>('core.delete')}
                </Button>
              </div>
            </div>
          </div>
        )
      })}
      <div className="p-fluid formgrid grid">
        <div className="field col-4">
          <Dropdown
            placeholder={i18n.t<string>('core.select')}
            options={phoneTypes}
            value={newPhoneType}
            itemTemplate={typeTemplate}
            valueTemplate={typeTemplate}
            onChange={(e) => {
              setNewPhoneType(e.target.value)
            }}
          />
        </div>
        <div className="field col-5">
          <InputText
            placeholder={'+41 79 123 45 67'}
            maxLength={60}
            value={newPhoneNumber}
            onChange={(e) => {
              setNewPhoneNumber(e.target.value)
            }}
          />
        </div>
        <div className="field col-3">
          <Button
            type="button"
            disabled={isButtonDisabled()}
            onClick={() => checkIfDuplicated()}
          >
            {i18n.t<string>('core.add')}
          </Button>
        </div>
      </div>
      <ConfirmDialog
        visible={showDuplicatedDialog}
        accept={() =>
          addPhone({ phone_number: newPhoneNumber, phone_type: newPhoneType })
        }
        onHide={() => setShowDuplicatedDialog(false)}
        header={t<string>('phone.duplicated.title', { value: newPhoneNumber })}
        message={t<string>('phone.duplicated.message')}
      />
    </>
  )
}